import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { HotKeys } from 'react-hotkeys';

import Button from '../../../../global/Button';
import { IMAGE_SIZE_CODE } from '../../../../../constants/image-size-codes';
import AlbumSlideshowThumbnailControls from './AlbumSlideshowThumbnailControls';
import PhotoUploadCache from '../../../../product/PhotoUploadCache';
import { getThumbBySize } from '../../../../../util/photo';

const propTypes = {
  slideshowPhoto: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  isSeen: PropTypes.bool,
  slideDuration: PropTypes.number,
  slideRemainingTime: PropTypes.number,
  className: PropTypes.string,
  onDelete: PropTypes.func,
  onMoveLeft: PropTypes.func,
  onMoveRight: PropTypes.func,
  style: PropTypes.object,
};

const AlbumSlideshowThumbnail = ({
  slideshowPhoto,
  onClick,
  isActive,
  isSeen,
  slideDuration,
  slideRemainingTime,
  className,
  onDelete,
  onMoveLeft,
  onMoveRight,
  disabled,
  style,
}) => {
  const classes = classNames({
    'slideshow-grid-viewer-thumbnail': true,
    'is-active': isActive,
    [className]: !!className,
  });

  return (
    <HotKeys
      keyMap={{
        onMoveRight: onMoveRight ? 'right' : undefined,
        onMoveLeft: onMoveLeft ? 'left' : undefined,
      }}
      handlers={{ onMoveRight, onMoveLeft }}
      style={style}
    >
      {isActive && (
        <AlbumSlideshowThumbnailControls
          disabled={disabled}
          onMoveLeft={onMoveLeft}
          onDelete={onDelete}
          onMoveRight={onMoveRight}
        />
      )}
      <Button btnStyle="reset" className={classes} onClick={onClick}>
        {(isSeen || isActive) && (
          <div
            style={{
              width: isSeen
                ? '100%'
                : `${100 - (100 * slideRemainingTime) / slideDuration}%`,
            }}
          />
        )}
        <PhotoUploadCache
          id={slideshowPhoto.asset_image?.id ?? slideshowPhoto.photo?.id}
          thumbs={
            slideshowPhoto.asset_image
              ? [
                  {
                    width: 1,
                    height: 1,
                    size_code: IMAGE_SIZE_CODE.SMALL2X,
                    ...slideshowPhoto.asset_image,
                  },
                ]
              : slideshowPhoto.photo.watermarked_urls ??
                slideshowPhoto.photo.thumbnail_urls ??
                []
          }
          render={thumbs => (
            <img
              src={getThumbBySize(thumbs, IMAGE_SIZE_CODE.SMALL2X, true)?.url}
              alt="Slideshow Thumbnail"
            />
          )}
        />
      </Button>
    </HotKeys>
  );
};

AlbumSlideshowThumbnail.propTypes = propTypes;

export default AlbumSlideshowThumbnail;
